import { useGlobalDIContext } from '@context/GlobalDIContext';
import { GET_CLIENT_PERMISSIONS, useUserApiDefaultConfig } from '@features/user/config';
import { ClientPermission } from '@g2-shared/api-client/generated/direct-money-gateway-app';
import { getServerErrorMessage } from '@g2-shared/common';
import { useQuery } from 'react-query';

interface useGetClientPermissionInterface {
  permissions?: ClientPermission;
  isLoading: boolean;
  errorMessage: string;
  hasSubService: (subService: string) => boolean;
}

export const useGetClientPermission = (enabled?: boolean): useGetClientPermissionInterface => {
  const config = useUserApiDefaultConfig('useGetClientPermission');
  const { DirectMoneyApiClient } = useGlobalDIContext();

  const { data, isLoading, error } = useQuery(
    [GET_CLIENT_PERMISSIONS],
    // @ts-ignore
    async () => {
      try {
        const response = await DirectMoneyApiClient.getClientPermission();
        return response.data.result;
      } catch (e: any) {
        console.log('GRESKA!!', e);
      }
    },
    {
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 2000,
      enabled,
    }
  );

  const hasSubService = (subService: string): boolean => {
    return !!data?.subservices && data.subservices.includes(subService);
  };

  return {
    permissions: data,
    isLoading,
    errorMessage: error ? getServerErrorMessage(error) : undefined,
    hasSubService,
  };
};
